// extracted by mini-css-extract-plugin
module.exports = {"icon":"Z_RxK","tooltip":"_31JvN","tooltipIcon":"_2vy4o"};